module.exports = __webpack_public_path__ + "img/mobile/BetBar/btn-sound_off@2x.png?0.0.53";